define('Terms.View', [
	'terms_pdp.tpl',
	'Backbone'
    ], function TermsView(
		acs_pd_main_tpl,
		Backbone
)
{
    'use strict';

	return Backbone.View.extend({

		template: acs_pd_main_tpl,
		initialize: function (options) {
			this.termsLink = options.container.getComponent('Environment').getConfig("PDPExtra.terms");
		},
		getContext: function getContext()
		{
			return {
				link: this.termsLink
			};
		}
	});
});
